// Header decorated by lines

import './HeaderWithLines.scss';

export default function HeaderWithLines({ children, btnText, onClick }) {
  return (
    <div className='header-with-lines'>
      <h5 className='header'>{children}</h5>
      {btnText && (
        <button className='small bw' onClick={onClick}>
          {btnText}
        </button>
      )}
    </div>
  );
}
